import { GeoTerritoryEntity } from '../entities';
import { authResource } from './Auth';
export const GeoTerritoryResource = authResource({
    path: '/geo/countries/:countryId/territories/:territoryId',
    schema: GeoTerritoryEntity
});
